class Experiments {
  set(experiments) {
    Object.keys(experiments || {}).forEach((name) => {
      this[name] = experiments[name]
    })
  }
}

export default new Experiments()
